import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSetAtom, useAtomValue } from 'jotai';
import { Tooltip, IconButton } from '@mui/material';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { openSnackbarAdviseAtom, userBranchesAtom } from '../../../Atoms';
import { createNewDate, compareDates } from '../../../Helpers/dates';
import ConfirmPopup from '../../../Components/Popup/ConfirmPopup';
import EntryComponent from '../../../Components/ContactListWrapper/EntryComponent';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';
import {
  OUTCOME_COLORS,
  counterChip,
  getChannelColumn,
} from '../Utils/constants';

const MassiveSMSEntry = function MassiveSMSEntry({
  messageData,
  campaignId,
  scheduledOn,
  handleDeleteMassiveSMS,
  handleOpenMassiveDetails,
}) {
  const intl = useIntl();
  const { massiveId, status, filters } = messageData;

  const parsedFilters = filters ? JSON.parse(filters) : {};
  const userBranches = useAtomValue(userBranchesAtom);
  const setOpenSnackbarAdviseAtom = useSetAtom(openSnackbarAdviseAtom);
  const [confirmDeletion, setConfirmDeletion] = useState(null);

  const handleOpenDeletionConfirmation = (event) => {
    event.stopPropagation(); //prevent row onClick function
    if (
      compareDates(
        createNewDate(scheduledOn), //date1 to compare
        new Date(), //date2 to compare
        'smaller' //compare operator
      )
    ) {
      setOpenSnackbarAdviseAtom({
        message: intl.messages.CANNOT_DELETE_MASSIVE,
        severity: 'warning',
      });
    } else {
      setConfirmDeletion(event.currentTarget);
    }
  };
  const handleCloseDeletionConfirmation = (event) => {
    event?.stopPropagation();
    setConfirmDeletion(null);
  };
  const confirmDeleteSMS = (event) => {
    event?.stopPropagation();
    setConfirmDeletion(null);
    handleDeleteMassiveSMS(massiveId, campaignId);
  };

  return (
    <>
      <EntryComponent
        data={{
          ...messageData,
          id: massiveId,
          branchName: userBranches?.find(
            (x) => x.id === parsedFilters?.Branches?.[0]
          )?.branchDescription,
        }}
        columns={[
          getChannelColumn(parsedFilters?.IsSMS, status, intl),
          {
            id: 'branchName',
            label: 'BRANCH',
            formatCallback: (value) => capitalize(value),
          },
          {
            id: 'enqueuedCustomers',
            label: 'CUSTOMERS_NUMBER',
            size: 'auto',
            formatCallback: (value) =>
              counterChip(value, OUTCOME_COLORS.CUSTOMERS),
          },
        ]}
        hideDivider
        statusSize="auto"
        customClick={() => handleOpenMassiveDetails(massiveId, campaignId)}
        customStatusChipCallback={() => (
          <Tooltip title={intl.messages.DELETE} placement="bottom">
            <IconButton
              id="delete-massive-button"
              onClick={handleOpenDeletionConfirmation}
            >
              <DeleteRoundedIcon />
            </IconButton>
          </Tooltip>
        )}
      />
      {/* outside the row so popup clicks don't bubble to the row onClick */}
      <ConfirmPopup
        open={Boolean(confirmDeletion)}
        anchorEl={confirmDeletion}
        close={handleCloseDeletionConfirmation}
        handleConfirm={confirmDeleteSMS}
        confirmText={intl.messages.CONFIRM_MESSAGE_DELETION}
      />
    </>
  );
};

export default MassiveSMSEntry;
